import React, { useState } from 'react';
import { TfiTrash } from 'react-icons/tfi';
import { LiaUserEditSolid } from 'react-icons/lia';
import { AiOutlineCheck } from 'react-icons/ai';
import { HiMiniXMark } from 'react-icons/hi2';

const CustomTooltip = ({ children, text, isVisible }) => {
  if (!isVisible) return children;
  
  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {children}
      <div style={{
        position: 'absolute',
        bottom: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#333',
        color: 'white',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        whiteSpace: 'nowrap',
        zIndex: 1000,
        marginBottom: '5px',
      }}>
        {text}
        <div style={{
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '5px solid transparent',
          borderRight: '5px solid transparent',
          borderTop: '5px solid #333',
        }}></div>
      </div>
    </div>
  );
};

const OrganizationUserActions = (props) => {
  const {
    index,
    showSelectMenu,
    handleEditClick,
    handleRemoveUserFromOrganization,
    handleUpdateUserRoleInOrganization
  } = props;

  const [activeTooltip, setActiveTooltip] = useState(null);

  const iconStyle = {
    margin: '5px',
    cursor: 'pointer'
  };

  return (
    <td>
      <span>
        {!showSelectMenu ? (
          <CustomTooltip 
            text="Edit User Role" 
            isVisible={activeTooltip === 'edit'}
          >
            <LiaUserEditSolid
              style={iconStyle}
              size={20}
              onClick={handleEditClick}
              onMouseEnter={() => setActiveTooltip('edit')}
              onMouseLeave={() => setActiveTooltip(null)}
            />
          </CustomTooltip>
        ) : (
          <>
            <CustomTooltip 
              text="Save" 
              isVisible={activeTooltip === 'save'}
            >
              <AiOutlineCheck
                onClick={handleUpdateUserRoleInOrganization}
                style={iconStyle}
                size={20}
                onMouseEnter={() => setActiveTooltip('save')}
                onMouseLeave={() => setActiveTooltip(null)}
              />
            </CustomTooltip>
            
            <CustomTooltip 
              text="Cancel" 
              isVisible={activeTooltip === 'cancel'}
            >
              <HiMiniXMark
                style={iconStyle}
                size={20}
                onClick={handleEditClick}
                onMouseEnter={() => setActiveTooltip('cancel')}
                onMouseLeave={() => setActiveTooltip(null)}
              />
            </CustomTooltip>
          </>
        )}
        
        <CustomTooltip 
          text="Remove User From Organization" 
          isVisible={activeTooltip === 'remove'}
        >
          <TfiTrash
            onClick={handleRemoveUserFromOrganization}
            style={iconStyle}
            size={20}
            onMouseEnter={() => setActiveTooltip('remove')}
            onMouseLeave={() => setActiveTooltip(null)}
          />
        </CustomTooltip>
      </span>
    </td>
  );
};

export default OrganizationUserActions;